// @flow
// An element inside a Bootstrap modal that is still being shown is
// display: none, so focus() does nothing. Focus now, and again once the modal
// is shown. Returns a cleanup that drops the pending retry.
export default function focusWhenModalShown(element: ?HTMLElement, focus: () => void): () => void {
  focus()

  const modal = element?.closest('.modal')
  if (!modal || modal.classList.contains('show'))
    return () => {}

  modal.addEventListener('shown.bs.modal', focus, {once: true})
  return () => modal.removeEventListener('shown.bs.modal', focus)
}
